export default __webpack_public_path__ + "static/media/bg2.6b0f7bdf.jpg";